<script setup lang="ts">
import TheBottomSheet from '@/components/TheBottomSheet.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import SpinnerIcon from '@/components/icons/SpinnerIcon.vue'
import { ref } from 'vue'
import { Vue3Lottie } from 'vue3-lottie'

defineProps<{
	show: boolean
	gift: {
		name?: string
		lottie: string
	}
	modalWrapperClass?: string
}>()
defineEmits(['hide'])

const isAnimationLoading = ref(true)
</script>

<template>
  <TheBottomSheet
    :show="show"
    :close-button="false"
    centered
    :wrapper-class="modalWrapperClass"
    @hide="$emit('hide')"
  >
    <div class="w-full flex flex-col items-center gap-4">
      <div
        class="flex items-center justify-center size-[316px]"
      >
        <SpinnerIcon
          v-if="isAnimationLoading"
          class="text-white w-10 min-w-10"
        />
        <Vue3Lottie
          class="rounded-xl"
          :class="isAnimationLoading && 'hidden'"
          :animation-link="gift.lottie"
          :auto-play="true"
          :loop="true"
          @on-animation-loaded="isAnimationLoading = false"
        />
      </div>

      <span
        v-if="gift.name"
        class="text-white text-center font-[700] text-[24px] leading-[32px] tracking-[-0.48px]"
      >
        {{ gift.name }}
      </span>

      <BaseButton
        style-type="secondary"
        class="mt-4 w-full"
        @click="$emit('hide')"
      >
        Close
      </BaseButton>
    </div>
  </TheBottomSheet>
</template>

<style scoped>

</style>